__turbopack_export_value__({
  "body-logo-18": "promoCard-module-scss-module__1Iytua__body-logo-18",
  "body-text-12": "promoCard-module-scss-module__1Iytua__body-text-12",
  "body-text-14": "promoCard-module-scss-module__1Iytua__body-text-14",
  "body-text-16": "promoCard-module-scss-module__1Iytua__body-text-16",
  "body-text-18": "promoCard-module-scss-module__1Iytua__body-text-18",
  "body-text-20": "promoCard-module-scss-module__1Iytua__body-text-20",
  "body-text-24": "promoCard-module-scss-module__1Iytua__body-text-24",
  "body-text-24-2": "promoCard-module-scss-module__1Iytua__body-text-24-2",
  "body-text-heading-2": "promoCard-module-scss-module__1Iytua__body-text-heading-2",
  "body-text-heading-3": "promoCard-module-scss-module__1Iytua__body-text-heading-3",
  "body-text-medium-14": "promoCard-module-scss-module__1Iytua__body-text-medium-14",
  "body-text-medium-16": "promoCard-module-scss-module__1Iytua__body-text-medium-16",
  "body-text-medium-18": "promoCard-module-scss-module__1Iytua__body-text-medium-18",
  "body-text-medium2-18": "promoCard-module-scss-module__1Iytua__body-text-medium2-18",
  "body-text2-14": "promoCard-module-scss-module__1Iytua__body-text2-14",
  "body-text2-16": "promoCard-module-scss-module__1Iytua__body-text2-16",
  "button-primary-text": "promoCard-module-scss-module__1Iytua__button-primary-text",
  "button-text": "promoCard-module-scss-module__1Iytua__button-text",
  "button2-text": "promoCard-module-scss-module__1Iytua__button2-text",
  "card": "promoCard-module-scss-module__1Iytua__card",
  "card-shadow": "promoCard-module-scss-module__1Iytua__card-shadow",
  "cardTitle": "promoCard-module-scss-module__1Iytua__cardTitle",
  "effect-menu": "promoCard-module-scss-module__1Iytua__effect-menu",
  "header-1": "promoCard-module-scss-module__1Iytua__header-1",
  "imageWrapper": "promoCard-module-scss-module__1Iytua__imageWrapper",
  "main-container": "promoCard-module-scss-module__1Iytua__main-container",
  "main-footer-container": "promoCard-module-scss-module__1Iytua__main-footer-container",
  "main-header-container": "promoCard-module-scss-module__1Iytua__main-header-container",
  "period": "promoCard-module-scss-module__1Iytua__period",
  "txt-12-bold": "promoCard-module-scss-module__1Iytua__txt-12-bold",
  "txt-14-bold": "promoCard-module-scss-module__1Iytua__txt-14-bold",
  "txt-14-bold-caps": "promoCard-module-scss-module__1Iytua__txt-14-bold-caps",
  "txt-14-med": "promoCard-module-scss-module__1Iytua__txt-14-med",
  "txt-16-bold": "promoCard-module-scss-module__1Iytua__txt-16-bold",
  "txt-16-med": "promoCard-module-scss-module__1Iytua__txt-16-med",
  "txt-18-bold": "promoCard-module-scss-module__1Iytua__txt-18-bold",
  "txt-18-medium": "promoCard-module-scss-module__1Iytua__txt-18-medium",
  "txt-18-medium-24": "promoCard-module-scss-module__1Iytua__txt-18-medium-24",
  "txt-24-semi": "promoCard-module-scss-module__1Iytua__txt-24-semi",
});
